/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const translatedExampleSchema = z.object({
  id: z.number(),
  translated: z.string(),
});

export type ITranslatedExample = z.infer<typeof translatedExampleSchema>;
